<template>
  <div id="google-map-container2"/>
</template>
<script>
  import {Loader} from "@googlemaps/js-api-loader";

  export default {
    name: 'AMap',
    props: {
      'allSiteLocation': Array,
    },
    data() {
      return {
        loader: null, // 地图加载器
        map: null, // 地图对象
        geocoder: null, // 地理编码服务，提供正向地理编码、逆向地理编码
        marker: null, // 地图点标记
        markers: [], // 地图点标记
        coordinateSystem: null, // 定位用经纬度的坐标系
        latitude: 51.50663, // 定位用经纬度的纬度
        longitude: -0.07326, // 定位用经纬度的经度
        // latitude: 23.4416378, // 定位用经纬度的纬度
        // longitude: 116.7976291, // 定位用经纬度的经度

        addressInfo: null, // 地址信息
        placeId: null, // 地点id
        infowindow: null, // 卡片
      }
    },
    watch: {},
    mounted() {

      this.loader =
        new Loader(
          {
            apiKey: "AIzaSyDJ09rgFRRpLxHFEbaPE9dgXDgAbLoSqqU",
            // apiKey: "AIzaSyA94zSlnADlq1J5lcUgcxxT26ee9Y2HOBE",
            version: "weekly",
            // libraries: ["places", ""]
          }
        )
          .load()
          .then(
            () => {
              this.initMap();

            }
          );
    },
    beforeDestroy() {
      this.map = null;
      this.params4Locate_Watch = null;
    },
    methods: {

      /** 初始化地图页面 */
      initMap() {
        this.map = new google.maps.Map( // 实例化地图
          document.getElementById("google-map-container2"),
          {
            center: new google.maps.LatLng(this.latitude, this.longitude), // 初始化地图中心点
            // zoom: 15, // 缩放级别
            // 地图缩放参数
            zoom: 12,
            // 最大缩放参数
            maxZoom: 20,
            // 最小缩放参数
            minZoom: 4,
            // 禁用默认UI
            disableDefaultUI: true
          }
        );
        // this.geocoder = new google.maps.Geocoder(); // 实例化地理编码服务

        this.infoWindow = new google.maps.InfoWindow();
        // Try HTML5 geolocation.
        if (navigator.geolocation) {

          navigator.geolocation.getCurrentPosition(
          // navigator.geolocation.watchPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              // console.log("33333333333333")
              // this.infoWindow.setPosition(pos);
              // this.infoWindow.setContent("Location found.");
              // this.infoWindow.open(this.map);
              this.map.setCenter(pos);
            },
            (e) => {
              console.log(e,"-------====11111111111111222222")
              this.handleLocationError(true,  this.map.getCenter());
            }
          );
        } else {
          // Browser doesn't support Geolocation
          this.handleLocationError(false, this.map.getCenter());
        }
        this.lookAllSiteLocation();
      },
      handleLocationError(browserHasGeolocation, pos) {
        this.infoWindow.setPosition(pos);
        this.infoWindow.setContent(
          browserHasGeolocation
            ? "Error: The Geolocation service failed."
            : "Error: Your browser doesn't support geolocation."
        );
        this.infoWindow.open(this.map);
      },
      // 显示标识所有站点的信息
      lookAllSiteLocation(allSiteLocationNew) {

        if (this.marker) {
          this.marker.setMap(null);
          this.marker = null;
        }

        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];
        let sites = this.allSiteLocation;
        if (allSiteLocationNew != undefined) {
          sites = allSiteLocationNew;
        }
        if(sites == null || sites == undefined ){
          // console.log("33333333333333")
          return;
        }
        if(this.map == null){
          // console.log("4444444444444")
          return;
        }
        // console.log("2222222222222222222111111111")
        // console.log("lookAllSiteLocation--===111111111", sites)
        let iconBase = 'https://site.gdqunyu.com/profile/';
        let infoWindow_const = new google.maps.InfoWindow();
        const IconScaledSize = new google.maps.Size(28, 28);
        // Create markers.
        for (let i = 0; i < sites.length; i++) {

          if (sites[i].latitude !== 0 && sites[i].latitude !== 0) {
            let iconPath;
            if (sites[i].type === 0) {
              iconPath = iconBase + 'RecycleSite_Green.png';
            } else if (sites[i].type === 1) {
              iconPath = iconBase + 'RecycleSite_Yellow.png';
            } else {
              iconPath = iconBase + 'RecycleSite_Red.png';
            }
            // console.log(sites[i].number, "============", iconPath);
            const markerBase = new google.maps.Marker({
              position: new google.maps.LatLng(sites[i].latitude, sites[i].longitude),
              icon: {
                url: iconPath,
                scaledSize: IconScaledSize,
              },
              title: sites[i].number,
              map: this.map,
            });

            markerBase.addListener("click", (...e) => {
              // console.log(markerBase.getTitle(), markerBase.getId(), 111)
              infoWindow_const.close();
              // infoWindow_const.setContent(`<!--<div>` + markerBase.getTitle() + `</div>我换行了-->`);
              infoWindow_const.setContent(markerBase.getTitle());
              infoWindow_const.open(markerBase.getMap(), markerBase);
            });
            this.markers.push(markerBase);
          }
        }
      },
    }
  }

</script>
<style lang="css">
  #google-map-container2 {
    width: 100%;
    height: 100%;
  }
</style>
